import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
import EventBus from '@/util/bus'
import { EventBusKey } from '@/util/bus'
import { translateLang } from '@/data/i18n/translateLang'
import {
  bigPlankMenuList,
  partMenuList,
  otherMenuList,
} from '@/views/newPaiban/config/menuList'

interface MenuDataType {
  key: string
  type: string
  label:
    | typeof bigPlankMenuList[number]['label']
    | typeof partMenuList[number]['label']
    | typeof otherMenuList[number]['label']
  icon?: string
  isShow?: boolean
  children?: MenuDataType[]
  parentId: number
  id: number
}


const __default__ = {
  name: 'MMenu',
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    position: { default: () => {
      return {
        x: 0,
        y: 0,
      }
    } },
    data: { default: () => [] },
    zIndex: { default: 100 },
    positionStyle: { default: 'fixed' },
    isUseSaw: { type: Boolean, default: false }
  },
  setup(__props: any, { expose }) {

const props = __props as { position: {
      x: number
      y: number
    }, data: Array<MenuDataType>, zIndex: number, positionStyle: 'absolute' | 'fixed', isUseSaw: boolean }



const menuList = computed(() => props.data?.filter((item) => item.isShow) || [])

const show = ref(false)

// 选择菜单项
const handleSelectMenuItem = (e: Event, menuItem: MenuDataType) => {
  if (
    props.isUseSaw &&
    (menuItem.key.includes('rotate') || menuItem.key.includes('flip'))
  ) {
    return
  }
  if (!menuItem.children?.length) {
    EventBus.$emit(EventBusKey.SELECT_MENU_ITEM, menuItem)
  }
  closeMenu()
}

// 计算出菜单的位置
const position = computed(() => {
  return {
    left: props.position.x + 'px',
    top: props.position.y + 'px',
  }
})

// 打开菜单
const openMenu = () => {
  show.value = true
}

// 关闭菜单
const closeMenu = () => {
  show.value = false

  activeId.value = 0

  // 关闭菜单的时候，关闭所有子菜单
  mMenuRef.value?.forEach((item: any) => item?.closeMenu())
}

const mMenuRef = ref<any>(null)
const childrenPosition = ref({
  x: 0,
  y: 0,
})
const mMenuContainerRef = ref<HTMLDivElement | null>(null)
const menuItemRef = ref<HTMLDivElement[] | null>(null)
// 当前选择项id
const activeId = ref(0)
// 鼠标移入选项
const handleMouseOver = (e: MouseEvent, item: MenuDataType, index: number) => {
  if (!menuItemRef.value) return

  const { children } = item

  // 检查 mMenuContainerRef.value 是否存在
  if (!mMenuContainerRef.value) return
  const { width } = mMenuContainerRef.value.getBoundingClientRect()

  if (children && children.length) {
    childrenPosition.value = {
      x: width,
      y: 0,
    }

    // 打开当前菜单前，关闭所有子菜单
    mMenuRef.value?.forEach((item: any) => item?.closeMenu())

    activeId.value = item.parentId || item.id
    mMenuRef.value[index]?.openMenu()
  }
}

// 鼠标移出，暂不关闭子菜单
const handleMouseLeave = (e: MouseEvent, item: MenuDataType, index: number) => {
  // mMenuRef.value[index]?.closeMenu()
}

expose({
  openMenu,
  closeMenu,
})

return { __sfc: true,props, menuList, show, handleSelectMenuItem, position, openMenu, closeMenu, mMenuRef, childrenPosition, mMenuContainerRef, menuItemRef, activeId, handleMouseOver, handleMouseLeave, translateLang }
}

})